import { render, staticRenderFns } from "./weekly.vue?vue&type=template&id=adefaa90&scoped=true"
import script from "./weekly.vue?vue&type=script&lang=js"
export * from "./weekly.vue?vue&type=script&lang=js"
import style0 from "./weekly.vue?vue&type=style&index=0&id=adefaa90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adefaa90",
  null
  
)

export default component.exports